/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CompanyFromJSON, CompanyToJSON } from './Company';
export function CreateCompanyResponseDataFromJSON(json) {
    return CreateCompanyResponseDataFromJSONTyped(json, false);
}
export function CreateCompanyResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        company: !exists(json, 'company') ? undefined : CompanyFromJSON(json['company'])
    };
}
export function CreateCompanyResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        company: CompanyToJSON(value.company)
    };
}
